module.exports = __webpack_public_path__ + "static/img/cha-page-01.0ef2bad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha-page-01.png
// module id = SP6H
// module chunks = 1